module.exports = __webpack_public_path__ + "img/icon_map_37_off_011.bc6868cc.png";